var map = {
	"./angpao.webp": 2313,
	"./bonus.webp": 2314,
	"./gpi-rebate-m.webp": 2315,
	"./gpi-rebate.webp": 2316,
	"./hublot-watch-2018.webp": 2317,
	"./hublot-watch-2022.webp": 2318,
	"./iphone-13-pro-max.webp": 2319,
	"./iphone-14-pro-max.webp": 2320,
	"./login-to-m.webp": 2321,
	"./login-to.webp": 2322,
	"./mb.webp": 2323,
	"./mg-rebate-m.webp": 2324,
	"./mg-rebate.webp": 2325,
	"./np.webp": 2326,
	"./pointer.webp": 2327,
	"./pp-rebate-m.webp": 2328,
	"./pp-rebate.webp": 2329,
	"./sadface.webp": 2330,
	"./wallet-m.webp": 2331,
	"./wallet.webp": 2332,
	"./wheel-b.webp": 2333,
	"./wheel-btn.webp": 2334,
	"./wheel-indon-b.webp": 2335,
	"./wheel-indon.webp": 2336,
	"./wheel.webp": 2337
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 929;